import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { colors } from "../../../theme/theme";

export const ContentBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(3),
}));

export const ToggleLabel = styled(Typography)({
  color: colors.primary,
  fontSize: "14px",
  fontFamily: "'Quicksand', sans-serif",
});

export const checkboxSx = {
  color: colors.primary,
};

export const checkboxIconSx = {
  color: colors.success,
  opacity: 0.3,
};

export const checkboxCheckedIconSx = {
  color: colors.primary,
};
